export enum AuthProviderOptions {
  CREDENTIALS = "credentials",
  APPLE = "apple",
  GOOGLE = "google",
  MICROSOFT = "microsoft",
}

declare module "next-auth" {
  interface Session {
    databaseApiAccessToken: string;
    databaseApiRefreshToken: string;
    providerUserId: string;
    authProvider: AuthProviderOptions;
    error?: string;
    /**
     * Email of the admin impersonating this user via the "Log in as user"
     * tool, when the session was started from an impersonation custom token.
     * Undefined for normal sessions. Such sessions are read-only server-side
     * unless `impersonationWritable` is true.
     */
    impersonatedBy?: string;
    /**
     * True when the admin started a writable impersonation session (allowed to
     * modify the user's data). Read-only is the default.
     */
    impersonationWritable?: boolean;
  }
  interface User {
    id_token: string;
    firebase_refresh_token?: string;
    providerUserId: string;
    emailVerified?: boolean;
    isNewUser?: boolean;
    authProvider: AuthProviderOptions;
    impersonatedBy?: string;
    impersonationWritable?: boolean;
  }
}
